import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "../../../services/api";

import * as types from "../../types/configSyncType";

function* fetchCompanies(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);
    const newCompanies = response ? response.companies : [];

    yield put({ type: types.SET_CONFIG_SYNC_COMPANIES, payload: newCompanies });
  } catch (e) {
    yield put({
      type: types.ERROR_CONFIG_SYNC_COMPANIES,
      message: e ? e.message : "Error",
    });
  }
}

function* tableSaga() {
  yield takeLatest(types.LOAD_CONFING_SYNC_COMPANIES, fetchCompanies);
}

export default tableSaga;
